import { BrowserModule, Meta } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ShareModule } from './module/share.module';
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger'; // logging magic
import {CookieService} from 'ngx-cookie-service';
import {CookieLawModule} from 'angular2-cookie-law';

import { YoutubeService, YOUTUBE_API_KEY, YOUTUBE_API_URL, YOUTUBE_API_URL2, YOUTUBE_API_URL3 } from './services/social-media/youtube.service';
import { TwitchService, TWITCH_API_KEY, TWITCH_API_URL} from './services/social-media/twitch.service';
import { GiphyService, GIPHY_API, GIPHY_API_KEY} from './services/social-media/giphy.service';
import { VimeoService, VIMEO_API_KEY, VIMEO_API_URL} from './services/social-media/vimeo.service';
import { SoundcloudService, SOUNDCLOUD_API_KEY, SOUNDCLOUD_API_URL} from './services/social-media/soundcloud.service';
import { FacebookService, FACEBOOK_API_KEY, FACEBOOK_API_URL, FACEBOOK_API_URL2 } from './services/social-media/facebook.service';
import { SpotifyService, SPOTIFY_API_KEY, SPOTIFY_API_URL, SPOTIFY_API_URL2 } from './services/social-media/spotify.service';
import { BingService, BING_API_KEY, BING_API_URL } from './services/social-media/bing.service';
import { InstagramService, INSTAGRAM_API_URL_USER, INSTAGRAM_API_URL_USERSEARCH } from './services/social-media/instagram.service';
import { FlickrService, FLICKR_API, FLICKR_API_KEY, FLICKR_AUTH_KEY } from './services/social-media/flickr.service';



/* import Angular Material Tools Start */
import { AngularMaterialModule } from './angular-material.module';
import { HeaderComponent } from './components/fixed_components/header/header.component';
/* import Angular Material Tools End */

/* import Translate Tool Start */
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule, HttpHandler} from '@angular/common/http';
/* import Translate Tool End */

import { FooterComponent } from './components/fixed_components/footer/footer.component';
import { SearchboxComponent } from './components/fixed_components/searchbox/searchbox.component';
import { DialogDeleteBoardComponent } from './components/alerts/dialog-delete-board/dialog-delete-board.component';
import { DialogComponent } from './components/alerts/dialog/dialog.component';
import { RequestDialogComponent } from './components/alerts/request-dialog/request-dialog.component';
import { BoardFollowListComponent } from './components/fixed_components/board-follow-list/board-follow-list.component';
import { PlaylistComponent } from './components/fixed_components/playlist/playlist.component';
import { PlaylistContentComponent } from './components/fixed_components/playlist/playlist-content/playlist-content.component';
import { WhoooshieComponent } from './components/fixed_components/whoooshie/whoooshie.component';
import {SocialLoginModule, SocialAuthServiceConfig, FacebookLoginProvider} from 'angularx-social-login';
import { GoogleLoginProvider} from 'angularx-social-login';
import { FollowerFromBoardComponent } from './components/alerts/follower-from-board/follower-from-board.component';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { DummyComponent } from './components/alerts/dummy/dummy.component';
import { CreateBoardPostComponent } from './components/board/create-board-post/create-board-post.component';
import {ImageCropperModule} from 'ngx-image-cropper';
import { ResetPwComponent } from './components/alerts/reset-pw/reset-pw.component';
import { DebugComponent } from './components/debug/debug.component';
import { ProductComponent } from './product/product.component';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {NgxMasonryModule} from 'ngx-masonry';
import {TourMatMenuModule} from 'ngx-tour-md-menu';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';
import { ThanksForEmailVerificationComponent } from './components/alerts/thanks-for-email-verification/thanks-for-email-verification.component';
import { ImageCreatorComponent } from './components/alerts/image-creator/image-creator.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { BoardPostCreateComponent } from './components/board/board-post-create/board-post-create.component';
import { MessengerComponent } from './components/messenger/messenger.component';
import { FriendsFromUserComponent } from './components/alerts/friends-from-user/friends-from-user.component';
import { DialogDeleteUserComponent } from './components/alerts/dialog-delete-user/dialog-delete-user.component';

import * as environment from '../environments/environment';

const log_level: string = environment.environment.log_level;

export function HttpLoaderFactory(http: HttpClient) {
 // return new TranslateHttpLoader(http);
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SearchboxComponent,
    DialogDeleteBoardComponent,
    RequestDialogComponent,
    BoardFollowListComponent,
    PlaylistComponent,
    PlaylistContentComponent,
    WhoooshieComponent,
    DialogComponent,
    FollowerFromBoardComponent,
    DummyComponent,
    CreateBoardPostComponent,
    ResetPwComponent,
    DebugComponent,
    ProductComponent,
    ThanksForEmailVerificationComponent,
    ImageCreatorComponent,
    BoardPostCreateComponent,
    MessengerComponent,
    FriendsFromUserComponent,
    DialogDeleteUserComponent
  ],
    entryComponents: [
        DialogDeleteBoardComponent,
        FollowerFromBoardComponent,
        DialogComponent,
        CreateBoardPostComponent,
        ImageCreatorComponent,
        BoardPostCreateComponent,
        FriendsFromUserComponent,
        DialogDeleteUserComponent
    ],

  imports: [
    FormsModule,
    CookieLawModule,
    NgxMasonryModule,
    TourMatMenuModule.forRoot(),
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    LoggerModule.forRoot({level: NgxLoggerLevel[log_level], serverLogLevel: NgxLoggerLevel[log_level]}), // local logs //todo: find out where logs are stored
    TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
    }),
    AppRoutingModule,
    AngularMaterialModule,
    SocialLoginModule,
    ShareModule,
    ImageCropperModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxQRCodeModule,
    NgxLinkifyjsModule.forRoot(),
    TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
    }),
  ],
  providers: [

        CookieService,
        Meta,
        YoutubeService,
        {provide: YOUTUBE_API_KEY, useValue: YOUTUBE_API_KEY},
        {provide: YOUTUBE_API_URL, useValue: YOUTUBE_API_URL},
        {provide: YOUTUBE_API_URL2, useValue: YOUTUBE_API_URL2},
        {provide: YOUTUBE_API_URL3, useValue: YOUTUBE_API_URL3},
        {provide: TWITCH_API_KEY, useValue: TWITCH_API_KEY},
        {provide: TWITCH_API_URL, useValue: TWITCH_API_URL},
        {provide: GIPHY_API_KEY, useValue: GIPHY_API_KEY},
        {provide: GIPHY_API, useValue: GIPHY_API},
        {provide: VIMEO_API_KEY, useValue: VIMEO_API_KEY},
        {provide: VIMEO_API_URL, useValue: VIMEO_API_URL},
        {provide: SOUNDCLOUD_API_KEY, useValue: SOUNDCLOUD_API_KEY},
        {provide: SOUNDCLOUD_API_URL, useValue: SOUNDCLOUD_API_URL},
        {provide: SPOTIFY_API_KEY, useValue: SPOTIFY_API_KEY},
        {provide: SPOTIFY_API_URL, useValue: SPOTIFY_API_URL},
        {provide: SPOTIFY_API_URL2, useValue: SPOTIFY_API_URL2},
        {provide: FACEBOOK_API_KEY, useValue: FACEBOOK_API_KEY},
        {provide: FACEBOOK_API_URL, useValue: FACEBOOK_API_URL},
        {provide: FACEBOOK_API_URL2, useValue: FACEBOOK_API_URL2},
        {provide: INSTAGRAM_API_URL_USERSEARCH, useValue: INSTAGRAM_API_URL_USERSEARCH},
        {provide: INSTAGRAM_API_URL_USER, useValue: INSTAGRAM_API_URL_USER},
        {provide: FLICKR_API, useValue: FLICKR_API},
        {provide: FLICKR_API_KEY, useValue: FLICKR_API_KEY},
        {provide: FLICKR_AUTH_KEY, useValue: FLICKR_AUTH_KEY},
        {provide: BING_API_KEY, useValue: BING_API_KEY},
        {provide: BING_API_URL, useValue: BING_API_URL},

      {
          provide: 'SocialAuthServiceConfig',
          useValue: {
              autoLogin: false,
              providers: [
                  {
                      id: GoogleLoginProvider.PROVIDER_ID,
                      provider: new GoogleLoginProvider(
                          '815497333868-q16ajchugl1c0651qvgeqb6c94ujtss4.apps.googleusercontent.com'
                      ), //client id only
                  },
                  {
                      id: FacebookLoginProvider.PROVIDER_ID,
                      provider: new FacebookLoginProvider('2722302081383459'), //client id only
                  },
                  // {
                  //     id: AmazonLoginProvider.PROVIDER_ID,
                  //     provider: new AmazonLoginProvider(
                  //         'clientId'
                  //     ),
                  // },
              ],
          } as SocialAuthServiceConfig,
      },
      // {
      //     provide: ResolverForUser,
      //     useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => myHero
      // }


      // GoogleLoginProvider.initialize(getAuthServiceConfigs)
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
